// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/styling-" + {"1342": "83f20bbb6fed8c48","42832": "5924e9347b531c47",}[chunkId] + ".css"
}